(async function(algolia) {
  'use strict';

  const getAlgoliaResults = algolia.externals.getAlgoliaResults;
  const { config, translations, headerTemplate, productTemplate, footerTemplate } = algolia;

  // Filters for stock policy
  let stockPolicyFilter = '';

  if (algolia.config.stock_policy === 'deny') {
    // For 'deny' we will filter out all items based on inventory quantity
    stockPolicyFilter = 'inventory_quantity > 0';
  } else if (algolia.config.stock_policy === 'continue') {
    /**
     * For 'continue' we will filter on `inventory_available` attribute whose
     * value is dependent on:
     * `inventory_quantity > 0 OR inventory_policy == 'continue'`
     */
    stockPolicyFilter = 'inventory_available:true';
  }

  const index_suffix = await config.index_suffix;

  algolia.productsPlugin = {
    getSources({ query, setContext }) {
      return [
        {
          sourceId: 'products',
          getItems() {
            return getAlgoliaResults({
              searchClient: algolia.searchClient,
              queries: [
                {
                  indexName: config.index_prefix + 'products' + index_suffix,
                  query,
                  params: {
                    hitsPerPage: config.products_autocomplete_hits_per_page,
                    // clickAnalytics: config.analytics_enabled,
                    clickAnalytics: true,
                    filters: stockPolicyFilter,
                    distinct: algolia.config.show_products
                  },
                },
              ],
              transformResponse({ results, hits }) {               
                setContext({
                  nbProducts: results[0].nbHits,
                });
                return hits;
              },
            });
          },
          templates: {
            header({ html, state }) {
              const resource = translations.products;
              return headerTemplate({ html, state }, resource);
            },
            item({ item, html, components }) {
              const distinct = config.show_products;
              const variantInfo = !distinct && item.objectID !== item.id ? `?variant=${item.objectID}` : '';
              const itemLink = `${window.Shopify.routes.root}products/${item.handle}/${variantInfo}`;           
              const getConversionData = (event, item) => {
                if (!item.__autocomplete_queryID || !item.__autocomplete_indexName || !item.position) return;                
                const userTokenLocal = localStorage.getItem('_ALGOLIA_USER_TOKEN');
                localStorage.setItem('algolia_queryID', item.__autocomplete_queryID);
                localStorage.setItem('algolia_objectID', item.objectID);
                sessionStorage.setItem('algolia_autocomplete_product_handle', item.handle);
                const authenticatedUserToken = window.algoliaShopify?.authenticatedUserToken || undefined;
                aa('clickedObjectIDsAfterSearch', {    
                  userToken: userTokenLocal,       
                  authenticatedUserToken: authenticatedUserToken,
                  index: window.algoliaShopify.dynamicIndexName || item.__autocomplete_indexName,
                  eventName: 'clickedObjectIDsAfterSearch',                                    
                  queryID: item.__autocomplete_queryID,
                  objectIDs: [item.objectID],
                  positions: [item.position]
                });
            };
              return productTemplate({ item, html, components }, distinct, itemLink, getConversionData);
            },
            footer({ state, html }){
              const {autocomplete_see_all, products_autocomplete_hits_per_page} = config;
              const showFooter = autocomplete_see_all && state.context.nbProducts > products_autocomplete_hits_per_page
              return true && footerTemplate({ html, state });
            },
          },
        }
      ];
    },
  }
})(window.algoliaShopify);
